import ParticipantsModal from "../../../../ui/modals/ParticipantsModal";
import avatarImg from "../../../../../assets/img/demo/player-avatar-1.png";
import check from "../../../../../assets/svg/actions/icn-check-green-20px.svg";
import share from "../../../../../assets/svg/actions/icn-share-20px.svg";
import "../../../../../assets/sass/pages/scouting/shared-done-modal.scss";
import SA_ShareDone from "./SA_ShareDone";

class ShareReportModal extends ParticipantsModal {

    titles = {
        heading: "Share Evaluation Reports",
        sub_heading: "Please search and select who you want to share the evaluation reports with",
        submit: "Share Evaluation Report"
    };

    state = {
        participants: Array.from(Array(25).keys())
            .map((item, index) => ({
                key: index,
                avatar: avatarImg,
                name: 'Calvin Cooper',
                info: 'Scout | Canberry Football Club',
                selected: false,
            }))
    };

    onSubmit = () => {
        new SA_ShareDone().fire({
            onOpen: () => {
                this.closeModal();
            }
        })
    }

    activeIcon  = () => {
        return check;
    }

    inactiveIcon = () => {
        return share
    }
};

export default ShareReportModal;